export default class Evaluation {
    constructor(options) {
      Object.assign(this, options)
    }
    
    getPermissions(){
  
    }
  
    toSend() {
      return {
        id: this.id,
        studentId: this.student?.id ?? null,
        courseId: this.course?.id ?? null,
        qualification: this.qualification,
        observation: this.observation,
      }
    }
  }
  